import React, { Component } from 'react';
import MicrolinkCard from '../controls/MicrolinkCard';
// import MicrolinkCard from '@microlink/react';
import { connectionGet, connectionPut, connectionPost } from '../../utils/connection';
import Gravatar from 'react-gravatar';
import BookingsPersonalServices from './BookingsPersonalServices';
import TrialSchedule from './TrialSchedule';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

@inject('userStore')
class BookingsPersonalRow extends Component {
  constructor(props){
    super(props);
    this.state = {
      starred:false,
      booking_trial:null
    }
    this.onClick = this.onClick.bind(this);
    this.qHandlerClick = this.qHandlerClick.bind(this);
  }


  qHandlerClick(event, booking){
    event.preventDefault();
    this.props.qHandler(booking);
  }

  onClick(event, component, title){
    event.preventDefault();
    this.props.handler(this.props.booking, component, title);
  }


  render() {
    const {booking} = this.props;
    var lead = false;
    if (booking.artist_list){
      let bus_user_list = booking.artist_list.filter((artist) => artist.bus_user.user_id === this.props.userStore.id);
      if (bus_user_list.length > 0){
        lead = bus_user_list[0].is_trial_user;
      }
    }
    return (
        <div className="col-lg-12">
          <div className="card card-shadowed">
              <div className="media bb-1 border-fade">
                  <img className="avatar avatar-lg" src={booking.business.thumb} alt='NA'/>
                  <div className="media-body">
                      <p>
                          <strong className="fs-14">{booking.business.name}</strong>
                      </p>
                      <p><small>{booking.business.phone_primary} - <a href={"mailto:" + booking.business.contact_email}>{booking.business.contact_email}</a></small></p>
                  </div>
              </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="media">
                          <Gravatar email={this.props.booking.email} size={36} rating="pg" default="identicon" className="avatar" />
                          <div className="media-body">
                            <div className="fs-18" style={{lineHeight:16+"px"}}><small>Client</small><br/>{booking.full_name}{booking.phone !== '' ? <React.Fragment><br/><small>{booking.phone}</small></React.Fragment> : null}<br/><small>{booking.email}</small></div>

                          </div>
                       </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="media">
                          <i className="fs-30 fa fa-calendar"></i>
                          <div className="media-body">
                            <div className="fs-18" style={{lineHeight:16+"px"}}><small>Event Date</small><br/>{booking.date}<br/>{booking.days_until > 0 ? <small className="text-info text-center">{booking.days_until} day(s) away</small> : <small className="text-info">{booking.days_until * -1} day(s) ago</small> }</div>
                          </div>
                         </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="media">
                          <i className="fs-30 fa fa-clock-o"></i>
                          <div className="media-body">
                            <div className="fs-18" style={{lineHeight:16+"px"}}><small>Ready Time</small><br/>{booking.ready_time}</div>
                          </div>
                         </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="media">
                            <i className="fs-30 fa fa-map-marker"></i>
                            <div className="media-body">
                                <div className="fs-12" style={{lineHeight:16+"px"}}><small>Ready Location</small><br/>{booking.location_name} <a target="_blank" href={'http://maps.google.com/?q='+booking.address + booking.address2}><i className="fa fa-external-link text-info"></i></a>
                                <br/><small>
                                {booking.address}<br/>
                                {booking.address2}
                                </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pt-30">
                    <div className="col-md-12 col-lg-8">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="card card-outline-secondary">
                            <header className="card-header">
                              <h4 className="card-title card-title-bold"><i className="fa fa-lightbulb-o"></i> Inspiration Ideas</h4>
                            </header>
                            <div className="card-body">
                        {booking.inspiration_list.map((inspiration, index) => {
                          if (inspiration.sys_media_type_id === 3 && inspiration.url !== ''){
                            return (
                              <div className="card card-shadowed" key={index}>
                                <div className="card-body">
                                  <MicrolinkCard style={{maxWidth:100+"%"}} preview={inspiration.preview}/>
                                </div>
                                <footer className="card-footer flexbox">
                                  <p><em>{inspiration.contents}</em></p>
                                </footer>
                              </div>
                            );
                          }
                        })}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <BookingsPersonalServices event={booking} service_list={booking.service_list} artist_list={booking.artist_list}/>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-4">
                      {lead ?
                      <div className="row">
                        <div className="col-sm-12">
                          <TrialSchedule booking={booking} hideHint={false}/>
                        </div>
                      </div>
                      : null}
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="card card-outline-secondary">
                              <div className="card-body">
                                  <div className="flexbox align-items-baseline">
                                      <h6 className="text-uppercase ls-2"><i className="fa fa-file-pdf-o"></i> Documents</h6>
                                  </div>
                                  <div className="media-list">
                                  {booking.document_list.length === 0 ? <span className="badge badge-info">Published Documents will appear here</span> :booking.document_list.map((document, index) =>
                                    <div className="media media-single" key={index}>
                                        <i className="fa fa-file-pdf-o fs-30"></i>
                                        <a href={document.document.document_url} target="_blank">
                                          <span>{document.sys_doc_type}</span>
                                        </a>
                                    </div>
                                  )}
                                  </div>
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        );
    }
}

export default BookingsPersonalRow;



// WEBPACK FOOTER //
// ./src/components/business/BookingsPersonalRow.js